<div class="page">
    <div class="container">
        <div class="item row row_ai_center"><a routerLink="/orders/create-orders" [queryParams]="{ customerId: customerId }"  class="create_order btn dark_btn row fz_s fw_500 cursor_pointer">Создать заказ
            <span class="material-symbols-outlined fz_m">
                add
            </span></a></div>
        <div class="main_content">
            <div class="row main_info">
                <div class="col-10"><app-customer-info-card [customerId]="customerId"></app-customer-info-card></div>
                <div class="col-14"><app-comments-card [customerId]="customerId"></app-comments-card></div>
            </div>
            <div class="table_area">
                <div class="table_item">
                    <h3 class="fz_l table_title">Транзакции</h3>
                    <app-table prolong="" [dataMissing]="dataMissingPayment" [getPaymentType]="getPaymentsType" [heightTable]="heightTable"
                        [data]="payment" [columns]="columnsPayment" [pagination]="paymentPagination"
                        (pageChange)="onPageChangePayments($event)"><app-skeleton *ngIf="isLoading" height="35" margin="15" [count]="countSkeleton"></app-skeleton></app-table>
                </div>
                <div class="table_item">
                    <h3 class="fz_l table_title">Подписки</h3>
                    <app-table (modalProlong)="getSubscriptions()" prolong="prolong" [dataMissing]="dataMissingSubscriptions" [heightTable]="heightTable" [data]="subscriptions"
                        [columns]="columnsSubscription" [pagination]="subscriptionPagination"
                        (pageChange)="onPageChangeSubscriptions($event)"><app-skeleton *ngIf="isLoading" height="35" margin="15" [count]="countSkeleton"></app-skeleton></app-table>
                </div>
                <div class="table_item">
                    <h3 class="fz_l table_title">Заказы</h3>
                    <app-table prolong="" [path]="'orders'" [dataMissing]="dataMissingOrders" [heightTable]="heightTable" [getStatus]="getOrderStatuses"
                        [data]="orders" [columns]="columnsOrders" [pagination]="orderPagination"
                        (pageChange)="onPageChangeOrders($event)"><app-skeleton *ngIf="isLoading" height="35" margin="15" [count]="countSkeleton"></app-skeleton></app-table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-toastr></app-toastr>
